import React from 'react'
import styled from 'styled-components'

import { ArrowIcon } from '../icons/arrow-icon'
import { theme } from '../../lib/theme'
import { SIconSpan } from '../styles/Icons'

const SArrowIcon = styled(ArrowIcon)<{ flipped: boolean }>`
    z-index: 1;
    transform: rotate(${({ flipped }) => (flipped ? 0 : '180deg')});
    transition: transform 0.2s ease-in;
`

interface IChevronProps {
    color?: string
    flipped: boolean
    onClick?: () => void
    size?: number
}

const Chevron = ({ color, flipped, size = 14, onClick }: IChevronProps): React.ReactElement => {
    return (
        <SIconSpan onClick={onClick} data-testid="chevron" size={size}>
            <SArrowIcon flipped={!flipped} color={color ?? theme.brandColors.CA_Black} />
        </SIconSpan>
    )
}

export default Chevron
